<div class="a-date-r-s-slider-bg pct100 ">
    <div class="rel">
        <div class="a-date-r-s-slider a-date-r-s-end" [style.width.%]="rightBtnPosition">
            <div class="a-date-r-s-tooltip tc" [style.width.px]="tooltipWidth" #rightTooltip>
                <ng-container *ngIf="!rightTooltipTpl;else rightTpl"></ng-container><span></span>
            </div>
            <span (mousedown)="mousedownHandler($event)"></span>
        </div>
        <div class="a-date-r-s-slider a-date-r-s-start" [style.width.%]="leftBtnPosition">
            <div class="a-date-r-s-tooltip tc" [style.width.px]="tooltipWidth" #leftTooltip>
                <ng-container *ngIf="!leftTooltipTpl;else leftTpl"></ng-container><span></span>
            </div>
            <span (mousedown)="mousedownHandler($event)"></span>
        </div>
    </div>
</div>

<ng-template #leftTpl>
    <ng-container *ngTemplateOutlet="leftTooltipTpl"></ng-container>
</ng-template>

<ng-template #rightTpl>
    <ng-container *ngTemplateOutlet="rightTooltipTpl"></ng-container>
</ng-template>